import { AppListenerEntry } from '@/redux/create-store';
import { startAssistantConversation } from '@/redux/slices/assistant.slice';

export const epicStartAssistantConversation: AppListenerEntry = {
  actionCreator: startAssistantConversation,
  effect: async (_payload, { extra: { datalayerService } }) => {
    datalayerService.pushChatbotEvent('open');
  }
};
